import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect } from "react";

function AssetManagement() {
  useEffect(() => {
    document.title = "Vivosol Plant Performance Insights Hub - Asset Management";
  }, []);
  return (
    <div className="body d-flex flex-row align-items-stretch">
        <div className="contentNoSidebar p-5">
          <h1>Asset Management</h1>
        </div>
    </div>
  );
}

export default AssetManagement;
